import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Check } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import ServiceArtwork from './ServiceArtwork';
import { useLanguage } from '../contexts/LanguageContext';
import '../InnerRefresh.css';

const ServicePageTemplate = ({ translationPrefix: prefix }) => {
  const { t, language } = useLanguage();
  const title = t(`${prefix}.title`).replace(/Cryptocurrency|kryptowalutowych|nieruchomościowych/g, word => ({
    Cryptocurrency: 'Crypto\u00adcurrency',
    kryptowalutowych: 'krypto\u00adwalutowych',
    nieruchomościowych: 'nierucho\u00admościowych'
  }[word]));
  const signs = Array.from({ length: 7 }, (_, i) => t(`${prefix}.sign${i + 1}`))
    .filter((value, i) => value !== `${prefix}.sign${i + 1}`);
  return (
    <div className="tb-inner">
      <Header />
      <main>
        <section className="tb-inner-hero tb-service-hero tb-container">
          <div className="tb-inner-hero-copy">
            <h1 className="tb-service-title" data-testid="service-title">{title}</h1>
            <p className="tb-inner-lead">{t(`${prefix}.subtitle`)}</p>
            <Link to="/#consultation-form" className="tb-button" data-testid="service-cta">{t(`${prefix}.cta`)}<ArrowUpRight size={19} aria-hidden="true" /></Link>
          </div>
          <ServiceArtwork translationPrefix={prefix} />
        </section>
        <div className="tb-inner-body tb-container tb-inner-reading-grid">
          <article className="tb-inner-prose">
            <section id="understanding" className="tb-inner-section"><h2>{t(`${prefix}.whatIs`)}</h2><p>{t(`${prefix}.whatIsDesc`)}</p></section>
            <section id="warning-signs" className="tb-inner-section">
              <h2>{t(`${prefix}.signs`)}</h2>
              <ul className="tb-signs-list">{signs.map((sign, i) => <li key={i}><Check size={18} aria-hidden="true" /><span>{sign}</span></li>)}</ul>
            </section>
            <section id="our-approach" className="tb-inner-section"><h2>{t(`${prefix}.howWeHelp`)}</h2><p>{t(`${prefix}.howWeHelpDesc`)}</p></section>
          </article>
          <aside className="tb-inner-sidebar">
            <nav aria-label={language === 'pl' ? 'Na tej stronie' : 'On this page'} className="tb-inner-toc">
              <a href="#understanding">{t(`${prefix}.whatIs`)}<ArrowUpRight size={15} aria-hidden="true" /></a>
              <a href="#warning-signs">{t(`${prefix}.signs`)}<ArrowUpRight size={15} aria-hidden="true" /></a>
              <a href="#our-approach">{t(`${prefix}.howWeHelp`)}<ArrowUpRight size={15} aria-hidden="true" /></a>
            </nav>
            <div className="tb-inner-contact-note"><h3>{t('contacts.consultationsTitle')}</h3><p>{t('contacts.consultationsText')}</p><Link className="tb-inner-text-link" to="/#consultation-form">{t('services.getConsultation')}<ArrowUpRight size={17} aria-hidden="true" /></Link></div>
          </aside>
        </div>
      </main>
      <Footer />
    </div>
  );
};
export default ServicePageTemplate;
